// actionTypes.js
export const FETCH_SUBSCRIPTION_DATA_SUCCESS = 'FETCH_SUBSCRIPTION_DATA_SUCCESS';
export const FETCH_SUBSCRIPTION_DATA_FAILURE = 'FETCH_SUBSCRIPTION_DATA_FAILURE';
export const FETCH_COMMUNITY_CONTENT_INI = 'FETCH_COMMUNITY_CONTENT_INI';
export const FETCH_COMMUNITY_CONTENT_SUCCESS = 'FETCH_COMMUNITY_CONTENT_SUCCESS';
export const FETCH_COMMUNITY_CONTENT_FAILURE = 'FETCH_COMMUNITY_CONTENT_FAILURE';
